var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ae-address-panel"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('AeAddress',{attrs:{"address":_vm.address,"split-by":"9"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }